/**
 * Главный экспорт всех API клиентов
 * Создание базового axios instance с interceptors
 */
import axios from 'axios'
import { API_CONFIG } from './config'
import { setupAuthInterceptor } from './interceptors/auth.interceptor'
import { setupLocaleInterceptor } from './interceptors/locale.interceptor'
import { setupTimezoneInterceptor } from './interceptors/timezone.interceptor'

// Создаем базовый axios instance
export const apiClient = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.REQUEST_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Подключаем interceptors
setupAuthInterceptor(apiClient)
setupLocaleInterceptor(apiClient)
setupTimezoneInterceptor(apiClient)

// Export для использования в features
export { API_CONFIG, getCdnUrl } from './config'

// Импортируем сгенерированные API клиенты
import { ClientDataServiceApi } from './clients/client'
import { DealsServiceApi } from './clients/deals'
import { CloseReasonsServiceApi } from './clients/close-reasons'
import { PropertiesServiceApi } from './clients/properties'
import { CalendarServiceApi } from './clients/calendar'
import { SearchServiceApi } from './clients/search'
import { AgentsServiceApi } from './clients/agents'
import { AnalyticsServiceApi } from './clients/analytics'
import { HistoryServiceApi } from './clients/history'
import { PipelineServiceApi } from './clients/pipeline'
import { TasksServiceApi } from './clients/tasks'
import { DocumentsServiceApi } from './clients/documents'
import { LandingsServiceApi } from './clients/landings'
import { MeetingsServiceApi } from './clients/meetings'

// Создаем экземпляры API клиентов с настроенным axios instance
// Все запросы идут через nginx (BASE_URL)
export const clientDataApi = new ClientDataServiceApi(undefined, API_CONFIG.BASE_URL, apiClient)
export const dealsApi = new DealsServiceApi(undefined, API_CONFIG.BASE_URL, apiClient)
export const closeReasonsApi = new CloseReasonsServiceApi(undefined, API_CONFIG.BASE_URL, apiClient)
export const propertiesApi = new PropertiesServiceApi(undefined, API_CONFIG.BASE_URL, apiClient)
export const calendarApi = new CalendarServiceApi(undefined, API_CONFIG.BASE_URL, apiClient)
export const searchApi = new SearchServiceApi(undefined, API_CONFIG.BASE_URL, apiClient)
export const agentsServiceApi = new AgentsServiceApi(undefined, API_CONFIG.BASE_URL, apiClient)
export const analyticsApi = new AnalyticsServiceApi(undefined, API_CONFIG.BASE_URL, apiClient)
export const historyApi = new HistoryServiceApi(undefined, API_CONFIG.BASE_URL, apiClient)
export const pipelineApi = new PipelineServiceApi(undefined, API_CONFIG.BASE_URL, apiClient)
// tasks-service (DEV-1980): единый источник задач сделок, клиентов и агентов
// плюс справочник типов задач
export const tasksApi = new TasksServiceApi(undefined, API_CONFIG.BASE_URL, apiClient)
// meetings (DEV-2005): видеовстречи с клиентом — назначение, приглашения,
// записи с расшифровками и черновик квалификации по итогам разговора
export const meetingsApi = new MeetingsServiceApi(undefined, API_CONFIG.BASE_URL, apiClient)
// landings-service (DEV-1786): публикация лендингов и настройки их SEO
export const landingsApi = new LandingsServiceApi(undefined, API_CONFIG.BASE_URL, apiClient)
// documents-service (DEV-781/DEV-787): генерация PDF-документов по сделкам
export const documentsServiceApi = new DocumentsServiceApi(
  undefined,
  API_CONFIG.BASE_URL,
  apiClient,
)
